export default __webpack_public_path__ + "static/summer_containers86-885e89f27fd84dc3c18080c37af3572e.webp";